import type { ComponentType } from 'react';

const routes: Record<string, () => Promise<ComponentType>> = {
  '/login': () => import('../../pages/auth/LoginPage').then((page) => page.LoginPage),
  '/account': () => import('../../pages/auth/AccountPage').then((page) => page.AccountPage),
  '/strong-v3': () => import('../../pages/market/StrongV3Page').then((page) => page.StrongV3Page),
  '/strong-v3-turns': () => import('../../pages/market/StrongV3TurnsPage').then((page) => page.StrongV3TurnsPage),
  '/behavior-pool': () => import('../../pages/market/BehaviorPoolPage').then((page) => page.BehaviorPoolPage),
  '/watchlist': () => import('../../pages/market/WatchlistPage').then((page) => page.WatchlistPage),
  '/training': () => import('../../pages/TrainingPage').then((page) => page.TrainingPage),
  '/training/history': () => import('../../pages/TrainingHistoryPage').then((page) => page.TrainingHistoryPage),
  '/training/notes': () => import('../../pages/TrainingNotesPage').then((page) => page.TrainingNotesPage),
  '/ops-monitor': () => import('../../pages/OpsMonitorPage').then((page) => page.OpsMonitorPage),
  '/structure-v2': () => import('../../pages/StructureWorkstationPage').then((page) => page.StructureWorkstationPage),
};
routes['/'] = routes['/structure-v2'];

const loaded = new Map<string, Promise<ComponentType>>();

export function hasAppRoute(path: string): boolean { return path in routes; }

export function loadRoute(path: string): Promise<ComponentType> {
  const existing = loaded.get(path);
  if (existing) return existing;
  const load = routes[path];
  if (!load) return Promise.reject(new Error(`Unknown route: ${path}`));
  const pending = load().catch((error: unknown) => { loaded.delete(path); throw error; });
  loaded.set(path, pending);
  return pending;
}

export function preloadRoute(path: string): void {
  if (hasAppRoute(path)) void loadRoute(path).catch(() => {});
}
